import React, { useState } from 'react';
import './AdminLogin.scss';
import { FiUser, FiAlertCircle } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const AdminForgotPassword = () => {
    const [username, setUsername] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [focusedField, setFocusedField] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        if (!username) {
            setError('Vui lòng nhập tên đăng nhập hoặc email.');
            return;
        }
        setLoading(true);
        try {
            // Giả lập API call
            await new Promise(resolve => setTimeout(resolve, 1500));
            setSuccess('Hướng dẫn lấy lại mật khẩu đã được gửi. Vui lòng kiểm tra email của bạn.');
        } catch (err) {
            setError('Có lỗi xảy ra. Vui lòng thử lại.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-login-page">
            {/* Subtle background grid pattern */}
            <div className="admin-login-bg-grid" />

            {/* Animated border wrapper */}
            <div className="admin-login-border-wrapper">
                <div className="admin-login-border-glow" />
                <div className="admin-login-card">
                    {/* Brand Header */}
                    <div className="admin-login-brand">
                        <div className="admin-login-logo">
                            <img src={require('../../images/Logo/Logo HSV_Icon.jpg')} alt="HSV Logo" style={{ width: '48px', height: 'auto', objectFit: 'contain' }} />
                        </div>
                        <div className="admin-login-brand-text">
                            <span className="admin-login-brand-name">Healthcare Solution Việt Nam</span>
                            <span className="admin-login-brand-sub">Hệ Thống Quản Lý</span>
                        </div>
                    </div>

                    <div className="admin-login-divider" />

                    {/* Title */}
                    <div className="admin-login-header">
                        <h1 className="admin-login-title">Quên Mật Khẩu</h1>
                        <p className="admin-login-subtitle">Nhập tên đăng nhập hoặc email để lấy lại mật khẩu</p>
                    </div>

                    {/* Error Message */}
                    {error && (
                        <div className="admin-login-error">
                            <FiAlertCircle className="admin-login-error-icon" />
                            <span>{error}</span>
                        </div>
                    )}

                    {/* Success Message */}
                    {success && (
                        <div className="admin-login-error" style={{ background: '#ecfdf5', color: '#059669', borderColor: '#a7f3d0' }}>
                            <span>{success}</span>
                        </div>
                    )}

                    {/* Form */}
                    <form onSubmit={handleSubmit} className="admin-login-form" noValidate>
                        <div className={`admin-login-field ${focusedField === 'username' ? 'is-focused' : ''} ${username ? 'has-value' : ''}`}>
                            <label htmlFor="al-username">Tên đăng nhập hoặc Email</label>
                            <div className="admin-input-wrapper">
                                <FiUser className="admin-input-icon" />
                                <input
                                    id="al-username"
                                    type="text"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    placeholder="Nhập tên đăng nhập hoặc email"
                                    disabled={loading}
                                    autoComplete="username"
                                    onFocus={() => setFocusedField('username')}
                                    onBlur={() => setFocusedField(null)}
                                />
                            </div>
                        </div>

                        <button
                            type="submit"
                            className={`admin-login-button ${loading ? 'is-loading' : ''}`}
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <span className="admin-login-spinner" />
                                    <span>Đang xử lý...</span>
                                </>
                            ) : (
                                <span>Gửi Yêu Cầu</span>
                            )}
                        </button>
                    </form>

                    {/* Footer */}
                    <div className="admin-login-footer">
                        <span>Đã nhớ mật khẩu?</span>
                        <a href="/admin/auth/login">Quay lại đăng nhập</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminForgotPassword;
